var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'row': !_vm.full
}},[_c('div',{class:( _obj = {}, _obj[ _vm.$ALERT_COL ] = !_vm.full, _obj )},[_c('Alert',{staticClass:"alert-attention",attrs:{"icon":"IconImportant","title":_vm.name + ' is disabled'}},[_c('p',{staticClass:"mb-0"},[_vm._v("\n        Once you are satisfied with the customizations, "),_c('router-link',{staticClass:"alert-link",attrs:{"to":{ name: _vm.to }}},[_vm._v("click here to enable "+_vm._s(_vm.name)+" →")])],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }